/**
 * Client-side props builders for the auth-funnel interaction events
 * (`auth_gate_shown` / `auth_gate_clicked` / `auth_page_viewed`).
 *
 * Server-fired outcome events (LoginSucceeded, RegistrationSucceeded, …) are
 * captured directly in the auth route actions/loaders via trackEvent(); only
 * the client-observable moments go through this module + /api/ping/event.
 */

export type AuthGateSource = 'landlord_card' | 'contact_button';
export type AuthPage = 'login' | 'register';

export type AuthAnalyticsProps = Record<string, string | number | boolean | undefined>;

export function buildAuthGateAnalyticsProps(input: {
  locale: string;
  source: AuthGateSource;
  authenticated: boolean;
  requiresVerification: boolean;
}): AuthAnalyticsProps {
  return {
    locale: input.locale,
    source: input.source,
    authenticated: input.authenticated,
    requires_verification: input.requiresVerification,
  };
}

export function buildAuthPageViewedAnalyticsProps(input: {
  locale: string;
  page: AuthPage;
  returnToPresent: boolean;
  hasListingContext: boolean;
}): AuthAnalyticsProps {
  return {
    locale: input.locale,
    page: input.page,
    return_to_present: input.returnToPresent,
    has_listing_context: input.hasListingContext,
  };
}
